var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundBlueImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.001,
    height: 57.001,
    viewBox: "0 0 68.001 57.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_7",
    x: 0,
    y: 0,
    width: 68.001,
    height: 57.001,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Union_7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7-2",
    "data-name": "Union 7",
    d: "M14.747,11.117a13,13,0,1,0,0,25.768,24,24,0,1,0,0-25.768Z",
    transform: "translate(63.5 52.5) rotate(180)",
    fill: "#0d70d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlueImg);
export default __webpack_public_path__ + "static/media/BackgroundBlueImg.fb3e83b18bf359e237d4de14203a0eb2.svg";
export { ForwardRef as ReactComponent };